"use strict";
exports.__esModule = true;
exports.List = void 0;
var List_1 = require("./List");
var ListItem_1 = require("./ListItem");
var List = Object.assign(List_1.List, { Item: ListItem_1.ListItem });
exports.List = List;
//# sourceMappingURL=index.js.map